module.exports = __webpack_public_path__ + "img/BPPMP4.2d99c30c.png";